(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/self-exclusion-react/assets/react/components/games.js') >= 0) return;  svs.modules.push('/modules/self-exclusion-react/assets/react/components/games.js');
'use strict';

const {
  ControlGroup,
  Select,
  Option
} = svs.ui.ReactForm;
const {
  games
} = svs.selfExclusion.allGames;
const {
  isPnp,
  gamesLabelText
} = svs.selfExclusion.Constants;
const {
  poolsVerticalHelpText
} = svs.self_exclusion_react.data;
const Games = _ref => {
  let {
    onHandleGame,
    game,
    isSubmitted
  } = _ref;
  const handleChange = gameValue => {
    onHandleGame(gameValue);
  };
  return React.createElement(ControlGroup, {
    errorMessage: "Du m\xE5ste v\xE4lja ett spel",
    hasError: isSubmitted && !game,
    v2: true
  }, React.createElement("label", {
    className: "styled-label"
  }, gamesLabelText, React.createElement(Select, {
    id: "reactSelect",
    inverted: isPnp,
    onChange: e => handleChange(e.target.value),
    v2: true,
    value: game || ''
  }, React.createElement(Option, null), games.map(game => React.createElement(Option, {
    key: game.id,
    value: game.value
  }, game.label)))), poolsVerticalHelpText && React.createElement("p", {
    className: "help-text"
  }, poolsVerticalHelpText));
};
svs.selfExclusion.components.Games = Games;

 })(window);